import script from "./CuadreCaja.vue?vue&type=script&setup=true&lang=js"
export * from "./CuadreCaja.vue?vue&type=script&setup=true&lang=js"

import "./CuadreCaja.vue?vue&type=style&index=0&id=44d8ae71&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44d8ae71"]])

export default __exports__